<template>
<!-- Modal -->
  <div class="content-box-gray card modal fade" id="show-tsdetails-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content  ">
        <div class="modal-header title text-center">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="myModalLabel" v-html="timeslicedata.headline" ></h4>
        </div>
                    <div class=" content modal-body">
                        <div class="content">
                            <img v-if="timeslicedata.visual_option=='image'" style="width:100%;" :src="getFilePath(timeslicedata.image.file_path)"/>
                             <iframe  v-if="timeslicedata.visual_option=='video'" id="timeslicedata.id" :src="timeslicedata.videourl" width="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                            <div class="card" style="padding:.5em;">
                                    <h4>{{timeslicedata.headline}}<h6> @({{timeslicedata.created_at}})</h6></h4>
                                    <div class="row d-flex justify-content-between">
                                    <h5 class="col-6">Story:</h5>
                                    <p v-html="timeslicedata.text"></p>
                                    </div>
                                    <div class="d-flex flex-row justify-content-end">
                                </div>
                            </div>
                        </div>
                    </div>
    </div>
  </div>
</div>
</template>

<script>
import EventBus from '../../../event-bus';
export default {
    components:{

     },
    name: "TSDetailModal",
    data() {
        return {
            userdata:'',
            // visibilities: ['private', 'community', 'world'],
            timeslicedata: '',
        }
    },

    props: {
        timeslices:'',
        user:'',
    },
    mounted() {
        EventBus.$on('showFullTS', (data) => {
            console.error("showFullTS modal invoked");
            this.timeslicedata = data.timeslicedata;
            $('div#show-tsdetails-modal').modal('show');
        });

    },
    methods: {
        cancel() {
            $('div#show-tsdetails-modal').modal('hide');
        },
        getFilePath(filePath) {
            return "/storage/"+ filePath;
        },

    }
}
</script>

<style scoped>
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#ffc107;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}

</style>
